<template>
  <div class="group-wrapper">
    <FilterWrapper
      class="group-options"
      v-for="(filter, index) in filtersLocalValue"
      :key="getKey(index)"
      :filter="filter"
      :optionsList="optionsList"
      :dateRange="dateRange"
      :brandIds="brandIds"
      @remove="removeFilter(index)"
      @updateFilter="updateFilter(index, $event)"
    />
    <div class="group-options">
      <TertiaryBadge
        @click="addFilter"
      >
        AND
        <template v-slot:icon>
          <PlusIcon size="small" />
        </template>
      </TertiaryBadge>
      <span
        class="remove-group"
        @click="$emit('remove')">
        REMOVE GROUP
      </span>
    </div>
  </div>
</template>
<script>
import {
  TertiaryBadge,
  PlusIcon,
} from '@mikmak/components';
import FilterWrapper from './FilterWrapper';
import { cloneDeep } from 'lodash';
import utils from '../../../../../../../services/utils';

export default {
  props: {
    filters: {
      type: Array,
    },
    groupName: {
      type: String,
      required: true,
    },
    optionsList: {
      type: Array,
    },
    dateRange: {
      type: Object,
    },
    brandIds: {
      type: Array,
    },
  },
  data() {
    return {
      filtersLocalValue: cloneDeep(this.filters || []),
      groupId: '',
    };
  },
  methods: {
    getKey(index) {
      return `${this.groupName} - ${index} - ${this.groupId}`;
    },
    setNewGroupId() {
      this.groupId = utils.guid();
    },
    addFilter() {
      const emptyFilter = {
        key: '',
        operator: '',
        value: [],
      };

      this.filtersLocalValue.push(emptyFilter);
      this.$emit('updateGroup', this.filtersLocalValue);
    },
    removeFilter(index) {
      this.filtersLocalValue.splice(index, 1);
      if (!this.filtersLocalValue.length) this.addFilter();
      this.$emit('updateGroup', this.filtersLocalValue);
      this.setNewGroupId();
    },
    updateFilter(index, filter) {
      this.filtersLocalValue.splice(index, 1, filter);
      this.$emit('updateGroup', this.filtersLocalValue);
    },
  },
  computed: {
    isDefaultValue() {
      return this.filtersLocalValue?.length === 1 &&
        this.filtersLocalValue[0].key === '' &&
        this.filtersLocalValue[0].operator === '';
    },
  },
  watch: {
    filters() {
      this.filtersLocalValue = cloneDeep(this.filters || []);
      if (this.isDefaultValue) this.setNewGroupId();
    },
  },
  created() {
    this.setNewGroupId();
    if (!this.filtersLocalValue.length) this.addFilter();
  },
  components: {
    TertiaryBadge,
    PlusIcon,
    FilterWrapper,
  },
};
</script>
<style lang='scss' scoped>
.group-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  width: 100%;
  background: #F7FAFC;
  border: 1px solid #C1CCD4;
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 15px;
}
.group-options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.remove-group {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.5px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #778699;
  cursor: pointer;
}
</style>
